import React, { Component } from 'react';

class Ad extends Component {
  componentDidMount() {
    // AdSense script is loaded via HTML head for auto ads
    // Enable auto ads
    try {
      if (window.adsbygoogle) {
        // Enable auto ads
        (window.adsbygoogle = window.adsbygoogle || []).push({
          google_ad_client: "ca-pub-9694128345236317",
          enable_page_level_ads: true
        });
      }
    } catch (e) {
      console.log('AdSense auto ads error:', e);
    }
  }

  render() {
    return (
      <div className="ad-page" style={{
        padding: '20px',
        fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif',
        textAlign: 'center'
      }}>
        {/* Auto ads will be automatically placed by Google */}
      </div>
    );
  }
}

export default Ad;
